module.exports = "//cdn.mxpnl.com/static/asset-cache/a0016ffc5866c8ff5e03548b9fdf8ea5/iron/common/assets/images/charts/empty-data.svg";